import { render, staticRenderFns } from "./RelatorioLeiloesWindow.vue?vue&type=template&id=e1d70282&"
import script from "./RelatorioLeiloesWindow.vue?vue&type=script&lang=js&"
export * from "./RelatorioLeiloesWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports